import { render, staticRenderFns } from "./Housekeeping.vue?vue&type=template&id=71ff2431&"
import script from "./Housekeeping.vue?vue&type=script&lang=js&"
export * from "./Housekeeping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports